import { Anchor, ArrowsLeftRight, Boat, Compass, ArrowUpRight } from "@phosphor-icons/react";
import { motion } from "framer-motion";

const services = [
  { number: "01", title: "Barge fleeting", text: "Flexible fleeting support for loaded and empty barges, coordinated around your operating window.", icon: Anchor, className: "service-large" },
  { number: "02", title: "Vessel mooring", text: "Secure short- or extended-stay mooring for towboats, push boats, and project vessels.", icon: Boat },
  { number: "03", title: "Shifting & handling", text: "Responsive coordination for the critical moves that keep equipment and schedules aligned.", icon: ArrowsLeftRight },
  { number: "04", title: "Marine logistics", text: "Practical waterfront support for crews, vendors, inspections, repairs, and changing job requirements.", icon: Compass, className: "service-wide" },
];

export const Services = () => (
  <section id="services" className="section services-section" data-testid="services-section">
    <div className="section-heading">
      <div>
        <span className="eyebrow" data-testid="services-label">01 / What we do</span>
        <h2 data-testid="services-heading">The support between<br />arrival and underway.</h2>
      </div>
      <p data-testid="services-introduction">Clear communication, local coordination, and marine support shaped to the job—not the other way around.</p>
    </div>
    <div className="services-grid" data-testid="services-grid">
      {services.map((service, index) => {
        const Icon = service.icon;
        return (
          <motion.article
            key={service.number}
            className={`service-card ${service.className || ""}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.5, delay: index * 0.08 }}
            data-testid={`service-card-${service.number}`}
          >
            {index === 0 && <img src="https://images.unsplash.com/photo-1609631672871-7f8e65e132b2?auto=format&fit=crop&w=1600&q=88" alt="Vertical overhead view of three cargo barges positioned side by side" />}
            <div className="service-card-inner">
              <div className="service-card-top">
                <span data-testid={`service-number-${service.number}`}>{service.number}</span>
                <Icon size={31} weight="duotone" />
              </div>
              <h3 data-testid={`service-title-${service.number}`}>{service.title}</h3>
              <p data-testid={`service-description-${service.number}`}>{service.text}</p>
              <a href="#contact" data-testid={`service-inquiry-link-${service.number}`} aria-label={`Ask about ${service.title}`}>
                Ask about this service <ArrowUpRight size={17} weight="bold" />
              </a>
            </div>
          </motion.article>
        );
      })}
    </div>
  </section>
);